import React from 'react';

type LogCountsTextProps = {
  numTotalLines?: number;
  numQueriedLines: number;
  numFilteredLines: number;
};

export const LogCountsText = ({
  numTotalLines,
  numQueriedLines,
  numFilteredLines,
}: LogCountsTextProps) => {
  if (!numTotalLines) {
    return null;
  }

  const hasHiddenOlderLogs = numTotalLines > numQueriedLines;

  if (numQueriedLines > numFilteredLines) {
    return (
      <div className="mt-4 text-sm text-moon-600">
        Showing{' '}
        <span className="font-semibold">
          {numFilteredLines.toLocaleString()} matches
        </span>{' '}
        out of {numQueriedLines.toLocaleString()}{' '}
        {hasHiddenOlderLogs && 'most recent'} lines
      </div>
    );
  }

  if (hasHiddenOlderLogs) {
    return (
      <div className="mt-4 text-sm text-moon-600">
        Showing most recent {numQueriedLines.toLocaleString()} out of{' '}
        {numTotalLines.toLocaleString()} lines
      </div>
    );
  }

  return null;
};
